function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { useContext } from "react";
import PropTypes from "prop-types";
import cc from "classcat";
import { twMerge } from "tailwind-merge";
import { AccordionTrigger } from "@radix-ui/react-accordion";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { SidebarMenuItemContext } from "./SidebarMenuItemContext";
import NavLink from "../../../vendor/router/NavLink";
SidebarMenuItemContent.propTypes = {
    icon: PropTypes.node,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    target: PropTypes.string,
    to: PropTypes.string,
    isChild: PropTypes.bool
};
export default function SidebarMenuItemContent(_param) {
    var icon = _param.icon, children = _param.children, className = _param.className, to = _param.to, target = _param.target, _param_isChild = _param.isChild, isChild = _param_isChild === void 0 ? false : _param_isChild, props = _object_without_properties(_param, [
        "icon",
        "children",
        "className",
        "to",
        "target",
        "isChild"
    ]);
    var hasSubmenu = useContext(SidebarMenuItemContext).hasSubmenu;
    return /*#__PURE__*/ React.createElement("div", null, hasSubmenu && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(AccordionTrigger, _object_spread({
        className: cc([
            "group flex w-full items-center gap-x-3 px-10 pb-3 pt-4 text-base font-semibold text-black outline-none transition duration-300 dark:text-gray-200 md:hover:bg-blue-200 md:focus:bg-blue-200 md:dark:hover:bg-gray-700 md:dark:focus:bg-gray-700",
            className
        ])
    }, props), /*#__PURE__*/ React.createElement("div", null, icon), /*#__PURE__*/ React.createElement("div", {
        className: "text-start"
    }, children), hasSubmenu && /*#__PURE__*/ React.createElement(ChevronDownIcon, {
        className: "ml-auto h-4 w-4 transition group-data-[state=open]:rotate-180 group-data-[state=open]:transform md:h-5 md:w-5"
    }))), !hasSubmenu && /*#__PURE__*/ React.createElement(NavLink, _object_spread(_object_spread_props(_object_spread({
        to: to,
        target: target
    }, props), {
        className: function(param) {
            var isActive = param.isActive;
            return twMerge(cc([
                "group/navlink flex gap-x-3 px-10 py-4 text-base font-semibold text-black outline-none transition duration-300 dark:text-gray-200 md:hover:bg-blue-200 md:focus:bg-blue-200 md:dark:hover:bg-gray-700 md:dark:focus:bg-gray-700",
                {
                    "is-active text-blue-600 dark:text-blue-500": isActive,
                    "px-14 py-0": isChild,
                    "items-center": !isChild
                },
                className
            ]));
        }
    }), props), isChild && /*#__PURE__*/ React.createElement("div", {
        className: "relative flex items-center justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "z-20 rounded-full bg-gray-400 p-1 group-[.is-active]/navlink:bg-blue-500"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "absolute left-1/2 top-1/2 z-10 hidden h-1/2 w-[1px] -translate-x-1/2 transform bg-gray-400 group-first:block "
    }), /*#__PURE__*/ React.createElement("div", {
        className: "absolute left-1/2 top-0 z-10 h-full w-[1px] -translate-x-1/2 transform bg-gray-400 group-first:hidden group-last:hidden"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "absolute left-1/2 top-0 z-10 hidden h-1/2 w-[1px] -translate-x-1/2 transform bg-gray-400 group-last:block"
    })), icon, /*#__PURE__*/ React.createElement("div", {
        className: cc([
            {
                "py-4 pl-3": isChild
            }
        ])
    }, children)));
}
